var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isMultiLine ? 'dialog-selector-textarea' : 'dialog-selector-input'},[_vm._v(_vm._s(_vm.labelOfSelectedOption))])}
var staticRenderFns = []

export { render, staticRenderFns }